
  import { useState, useEffect } from "react";
  import { db } from "./Firebase";
  import {
    collection,
    doc,
    onSnapshot,
    getDoc,
    setDoc,
  } from "firebase/firestore";
  import Navbar from "./Navbar";
  import Foot from "./Foot";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
  import { useNavigate } from "react-router-dom";

  export default function Dashboard() {
    const [products, setProducts] = useState([]);
    const [cart, setCart] = useState([]);
    const [showCartModal, setShowCartModal] = useState(false);
    const [email, setEmail] = useState("user@example.com");
    const [displayedProducts, setDisplayedProducts] = useState(9);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedProduct, setSelectedProduct] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
      const unsubscribe = onSnapshot(collection(db, "Products"), (snapshot) => {
        const productsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(productsData);
      });

      const storedEmail = localStorage.getItem("email") || "user@example.com";
      setEmail(storedEmail);

      const fetchCart = async () => {
        try {
          const cartDocRef = doc(db, "Cart", storedEmail);
          const cartSnapshot = await getDoc(cartDocRef);
          if (cartSnapshot.exists()) {
            setCart(cartSnapshot.data().items || []);
          } else {
            setCart([]);
          }
        } catch (error) {
          console.error("Error fetching cart:", error);
        }
      };

      fetchCart();

      return () => unsubscribe();
    }, []);

    const saveCartToFirestore = async (updatedCart) => {
      try {
        const cartDocRef = doc(db, "Cart", email);
        await setDoc(cartDocRef, { items: updatedCart });
      } catch (error) {
        console.error("Error saving cart:", error);
      }
    };

    const filteredProducts = products.filter((product) => {
      const searchTerm = searchQuery.toLowerCase();
      return (
        product.Name.toLowerCase().includes(searchTerm) ||
        product.Description.toLowerCase().includes(searchTerm)
      );
    });

    const addToCart = (product) => {
      setCart((prevCart) => {
        const updatedCart = prevCart.some((item) => item.id === product.id)
          ? prevCart.map((item) =>
              item.id === product.id
                ? { ...item, quantity: item.quantity + 1 }
                : item
            )
          : [...prevCart, { ...product, quantity: 1 }];

        localStorage.setItem("cart", JSON.stringify(updatedCart));
        saveCartToFirestore(updatedCart);
        return updatedCart;
      });
    };

    const removeFromCart = (productId) => {
      setCart((prevCart) => {
        const updatedCart = prevCart.filter((item) => item.id !== productId);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        saveCartToFirestore(updatedCart);
        return updatedCart;
      });
    };

    const toggleCartModal = () => {
      setShowCartModal(!showCartModal);
    };

    const goToCheckout = () => {
      navigate("/billing", { state: { cart } });
    };

    const loadMoreProducts = () => {
      setDisplayedProducts((prevCount) => prevCount + 9);
    };

    return (
      <>
        <div className="d-flex flex-column flex-lg-row">
          <Navbar />

          <div className="col-12 col-lg-12 mt-5 pt-5 back">
            <div className="container">
              <h1 className="text-center text-primary mb-4 display-3 font-weight-bold">
                Welcome to the KP Bakers
              </h1>
              <h5 className="text-center text-warning mb-4 font-weight-bold">We make on Order, we serve on Order..</h5>

              <div className="mb-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search products..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              <div className="text-center text-light my-4">
                <button className="btn btn-success" onClick={toggleCartModal}>
                <span><img src="https://img.icons8.com/?size=100&id=G7PELQpF8j6g&format=png&color=FFFFFF" width="30px"/></span>View Cart ({cart.length})
                </button>
              </div>

              <div className="row">
                {filteredProducts.slice(0, displayedProducts).map((product) => (
                  <div className="col-md-4 col-sm-6 mb-4" key={product.id}>
                    <div className="card shadow-lg rounded border-0">
                      <img
                        src={
                          product.ImageUrl ||
                          "https://via.placeholder.com/300x200"
                        }
                        className="card-img-top rounded-top product-image"
                        alt={product.Name}
                        onError={(e) =>
                          (e.target.src = "https://via.placeholder.com/300x200")
                        }
                      />
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title text-primary">
                          {product.Name}
                        </h5>
                        <h6 className="card-subtitle mb-2 text-muted">
                          Price: ₹{product.Price}
                        </h6>
                        <p className="card-text product-description">
                          {product.Description.length > 100
                            ? `${product.Description.slice(0, 100)}...`
                            : product.Description}
                        </p>
                        {product.Description.length > 100 && (
                          <button
                            className="btn btn-link text-primary p-0"
                            onClick={() => setSelectedProduct(product)}
                          >
                            View More
                          </button>
                        )}
                        <button
                          className="btn btn-primary mt-auto w-100"
                          onClick={() => addToCart(product)}
                        >
                          <FontAwesomeIcon
                            icon={faShoppingCart}
                            className="mr-2"
                          />
                          Add to Cart
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
                {filteredProducts.length === 0 && (
                  <div className="text-center text-muted w-100">
                    <p>No products match your search. Try a different query!</p>
                  </div>
                )}
              </div>

              {displayedProducts < filteredProducts.length && (
                <div className="text-center mt-4">
                  <button className="btn btn-primary" onClick={loadMoreProducts}>
                    Show More
                  </button>
                </div>
              )}

              {/* Cart Modal */}
              {showCartModal && (
                <div
                  className="modal fade show"
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                  }}
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content shadow-lg">
                      <div className="modal-header bg-primary text-white">
                        <h5 className="modal-title">Your Cart</h5>
                        <button
                          type="button"
                          className="close"
                          aria-label="Close"
                          onClick={toggleCartModal}
                        >
                          <span aria-hidden="true">⛒</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        {cart.length === 0 ? (
                          <p>Your cart is empty. Add some products!</p>
                        ) : (
                          <>
                            <ul className="list-group">
                              {cart.map((item) => (
                                <li
                                  key={item.id}
                                  className="list-group-item d-flex justify-content-between align-items-center"
                                >
                                  <span>
                                    {item.Name} (x{item.quantity})
                                  </span>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => removeFromCart(item.id)}
                                  >
                                    Remove
                                  </button>
                                </li>
                              ))}
                            </ul>
                            <div className="text-right mt-4">
                              <h4>
                                Total: ₹
                                {cart
                                  .reduce(
                                    (total, item) =>
                                      total + item.Price * item.quantity,
                                    0
                                  )
                                  .toFixed(2)}
                              </h4>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={toggleCartModal}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={goToCheckout}
                        >
                          Checkout
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Product Details Modal */}
              {selectedProduct && (
                <div
                  className="modal fade show"
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content shadow-lg">
                      <div className="modal-header bg-primary text-white">
                      
                        <button
                          type="button"
                          className="btn btn text-light"
                          onClick={() => setSelectedProduct(null)}
                        >
                          
                          <span>⛒</span>
                        </button>
                        <h5 className="modal-title">{selectedProduct.Name}</h5>
                      </div>
                      <div className="modal-body">
                        <img
                          src={
                            selectedProduct.ImageUrl ||
                            "https://via.placeholder.com/300x200"
                          }
                          alt={selectedProduct.Name}
                          className="img-fluid mb-3"
                        />
                        <p>
                          <strong>Price:</strong> ₹{selectedProduct.Price}
                        </p>
                        <p>
                          <strong>Description:</strong>{" "}
                          {selectedProduct.Description}
                        </p>
                      </div>
                      <div className="modal-footer">
                        <button
                          className="btn btn-secondary"
                          onClick={() => setSelectedProduct(null)}
                        >
                          Close
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={() => addToCart(selectedProduct)}
                        >
                          Add to Cart
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <Foot />
          </div>
        </div>

        {/* Inline Styling */}
        <style jsx>{`
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');

    * {
      font-family: 'Poppins', sans-serif;
      scroll-behavior: smooth;
    }

    .card {
      transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out, opacity 0.4s ease;
      border-radius: 12px;
      overflow: hidden;
      height: 100%;
      opacity: 0;
      animation: fadeIn 0.6s ease-in forwards;
    }

    .card:hover {
      transform: translateY(-10px) scale(1.02);
      box-shadow: 0 15px 25px rgba(0, 0, 0, 0.2);
    }

    .btn {
      transition: background-color 0.3s ease-in-out, transform 0.2s ease;
      font-weight: bold;
      position: relative;
      overflow: hidden;
      z-index: 1;
    }

    .btn::before {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      width: 300%;
      height: 300%;
      background: rgba(255, 255, 255, 0.3);
      transition: all 0.6s ease;
      border-radius: 50%;
      transform: translate(-50%, -50%) scale(0);
      z-index: 0;
    }

    .btn:hover::before {
      transform: translate(-50%, -50%) scale(1);
    }

    .btn:hover {
      background-color: #004080;
      transform: scale(1.05);
    }

    .back {
      background-image: url(https://thumbs.dreamstime.com/b/empty-space-baking-background-ingredients-bakery-flour-milk-eggs-rolling-pin-simple-pastry-flat-lay-top-view-border-342725138.jpg);
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
      animation: fadeBackground 10s ease-in-out infinite alternate;
    }

    .product-image {
      width: 100%;
      height: 200px;
      object-fit: cover;
      transition: transform 0.4s ease;
    }

    .product-image:hover {
      transform: scale(1.05);
    }

    .product-description {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transition: all 0.3s ease-in-out;
    }
      

    .card-body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }

    .modal-content {
      border-radius: 12px;
      animation: slideUp 0.4s ease-out;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    }

    .modal-header {
      border-bottom: 2px solid #ddd;
      background-color: #0072ff;
    }

    .modal-header .close {
      color: #fff;
      opacity: 1;
    }

    .modal-footer {
      border-top: 1px solid #ddd;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes slideUp {
      from {
        transform: translateY(30px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }

    @keyframes fadeBackground {
      from {
        background-position: top;
      }
      to {
        background-position: bottom;
      }
    }
  `}</style>

      </>
    );
  }
